<!-- Footer Section Begin -->
<footer class="footer">
    <div class="container">
        <div class="row">
            <!-- Logo Section -->
            <div class="col-lg-3 col-md-12">
                <div class="footer__logo">
                    <a routerLink="/"><img src="assets/img/logo/yogamez-hub-dark-480.png" srcset="assets/img/logo/yogamez-hub-dark-240.png 240w, assets/img/logo/yogamez-hub-dark-480.png 480w" sizes="(max-width: 480px) 120px, (max-width: 768px) 140px, 205px" alt="YoGamez HUB" width="205" height="79" loading="lazy"></a>
                </div>
            </div>

            <!-- About Section -->
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="footer__section">
                    <h4 class="footer__title">About</h4>
                    <ul class="footer__links">
                        <li><a (click)="routeToPage('/news-promotions')" class="footer-link">News & Promotions</a></li></ul>
                </div>
            </div>

            <!-- Legal Section -->
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="footer__section">
                    <h4 class="footer__title">Legal</h4>
                    <ul class="footer__links">
                        <li><a (click)="routeToPage('/privacy-policy')" class="footer-link">Privacy Policy</a></li>
                        <li><a (click)="routeToPage('/terms')" class="footer-link">Terms & Conditions</a></li>
                    </ul>
                </div>
            </div>

            <!-- Support Section -->
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="footer__section">
                    <h4 class="footer__title">Support</h4>
                    <ul class="footer__links">
                        <li><a (click)="routeToPage('/contact-us')" class="footer-link">Contact Us</a></li>
                        <li><a (click)="routeToPage('/faq')" class="footer-link">FAQs</a></li>
                    </ul>
                </div>
            </div>

            <!-- Social Media Section -->
            <div class="col-lg-3 col-md-12">
                <div class="footer__social">
                    <a href="https://www.facebook.com/econetzimbabwe" class="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><i class="fa fa-facebook-f"></i></a>
                    <a href="https://x.com/econetzimbabwe" class="social-icon" aria-label="Twitter" target="_blank" rel="noopener noreferrer"><i class="fa fa-twitter"></i></a>
                    <a href="https://www.instagram.com/econetzimbabwe" class="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><i class="fa fa-instagram"></i></a>
                    <a href="https://www.youtube.com/@econetzimbabwe" class="social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer"><i class="fa fa-youtube"></i></a>
                </div>
            </div>
        </div>

        <!-- Footer Bottom -->
        <div class="row">
            <div class="col-12">
                <div class="footer__bottom">
                    <div class="footer__copyright">
                        <p>© YogamezHub 2025</p>
                    </div>
                    <div class="footer__settings">
                        <a (click)="routeToPage('/cookies')" class="footer-link">Cookies Settings</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- Footer Section End -->
